import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=5bde7e10&lang=html"
import script from "./InputCurrency.vue?vue&type=script&lang=js"
export * from "./InputCurrency.vue?vue&type=script&lang=js"
import style0 from "./InputCurrency.vue?vue&type=style&index=0&id=5bde7e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports